// extracted by mini-css-extract-plugin
export default {"formContainer":"AssignmentView_formContainer__NaxZN","form":"AssignmentView_form__vdXH0"};